import React from 'react'

import { NoAdminAccess } from 'enrollment-platform/rbac/NoAdminAccess'

import useCompanyAccess from './useCompanyAccess'

interface Props {
  children: React.ReactNode
}

/**
 * Gates the Company page when the EPS global flag
 * `service.eps.us-restricted-data.enable-enforcement` is on (no-op when off).
 * Client Admins pass on role alone; every other role the route admits
 * must also hold Manage on UsRestrictedData. Denied users see an in-page Access
 * Denied state instead of being redirected. Fail-closed on an ability error,
 * like AdminPortalGate. UX only — the EPS AbilityGuard is the real boundary.
 */
export default function CompanyAccessGate({ children }: Props) {
  const { hasAccess, isLoading } = useCompanyAccess()
  // Hold until access is known so the page doesn't flash before a denial.
  if (isLoading) return null
  if (!hasAccess) {
    return (
      <NoAdminAccess
        title="Access Denied"
        message="You don’t have permission to view this page. Please contact your administrator to request access, then refresh."
      />
    )
  }
  return <>{children}</>
}
